import { c as _c } from "react/compiler-runtime";
import React from 'react';
import LoadingAnimation from '@/assets/images/loading-animation.png';
import LoadingAnimationBg from '@/assets/images/loading-animation-bg.png';
import Image from 'next/image';
import { useTranslation } from 'react-i18next';
function Loader(t0) {
  const $ = _c(10);
  const {
    hideLabel,
    label,
    className
  } = t0;
  const {
    t
  } = useTranslation("core");
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Image src={LoadingAnimation} alt={"Na\u010D\xEDt\xE1 se"} className="absolute left-1/2 top-1/2 w-full h-auto -translate-x-2/4 -translate-y-2/4 z-30" />;
    t2 = <Image src={LoadingAnimationBg} alt={"Na\u010D\xEDt\xE1 se"} className="absolute left-1/2 top-1/2 w-full h-auto -translate-x-2/4 -translate-y-2/4 z-30" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="relative mx-auto flex h-[15.5rem] w-[18.75rem] items-center justify-center">{t1}{t2}<svg className="animate-loader-rotate z-20 m-auto h-36 w-36 text-blue-500 lg:w-48" viewBox="25 25 50 50"><circle className="animate-loader-dash" cx="50" cy="50" r="20" fill="none" stroke="currentColor" strokeWidth="1.5" style={{
          strokeDasharray: "150, 200",
          strokeDashoffset: "-10",
          strokeLinecap: "round"
        }} /></svg><div className="animate-loader-flash absolute top-2/4 left-2/4 z-10 h-30 w-30 -translate-x-2/4 -translate-y-2/4 rounded-[50%] bg-white opacity-1 will-change-[opacity]" /></div>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== hideLabel || $[4] !== label || $[5] !== t) {
    t4 = !hideLabel && <p className="text-center text-lg font-bold lg:text-2xl">{label || t("loadingLabel")}</p>;
    $[3] = hideLabel;
    $[4] = label;
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== className || $[8] !== t4) {
    t5 = <div className={className}>{t3}{t4}</div>;
    $[7] = className;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}
export default Loader;